import React from "react";
import PropTypes from "prop-types";
import PrimaryButton from "./Button/Primary";

const ErrorRetry = ({ message, onRetry, retryButton }) => {
  const button =
    typeof retryButton !== "undefined" ? (
      retryButton
    ) : (
      <PrimaryButton onClick={onRetry}>Retry</PrimaryButton>
    );

  return (
    <>
      <p>{message}</p>
      {button}
    </>
  );
};

ErrorRetry.propTypes = {
  onRetry: PropTypes.func.isRequired,
  message: PropTypes.string,
  retryButton: PropTypes.any
};

ErrorRetry.defaultProps = {
  message: "There was an error while trying to get your data. Please try again."
};

export default ErrorRetry;
